
/* injects from baggage-loader */

'use strict';

const moduleEditorLibrary = angular.module('factory.editorLibrary', []);

moduleEditorLibrary.factory('EditorLibrary', [
  '$interval', 'Notification', '$filter',
  ($interval, Notification, $filter) => {
    const BUILD_QUEUED = 'queued';
    const BUILD_WORKING = 'working';
    const BUILD_RETRYING = 'retrying';
    const BUILD_COMPLETE = 'complete';
    const BUILD_FAILED = 'failed';
    const BUILD_STOPPED = 'stopped';
    const BUILD_INTERRUPTED = 'interrupted';

    class EditorLibrary {
      constructor() {
        this.intervalId = null;
      }

      showBuildStatus(Section, $scope, type, intervalPeriod, intervalStep, maxIntervalCount) {
        $scope.buildIsNotFinish = true;
        $scope.buildingType = type;

        if (this.intervalId) {
          this.clearInterval();
        }

        let intervalCount = 0;

        this.intervalId = $interval(() => {
          Section.getBuildStatus().then((response) => {
            if (response && response.build_status) {
              switch (response.build_status) {
                case BUILD_QUEUED:
                case BUILD_WORKING:
                case BUILD_RETRYING: {
                  break;
                }
                case BUILD_COMPLETE: {
                  this.clearInterval();
                  $scope.buildIsNotFinish = false;
                  break;
                }
                case BUILD_FAILED:
                case BUILD_STOPPED:
                case BUILD_INTERRUPTED: {
                  console.error(`Build is failure, status: ${response.build_status}`);
                  this.clearInterval();
                  this.onBuildFailure($scope);
                  break;
                }
              }
            }

            // Если период стал слишком большим, то остановим запросы и выведем ошибку
            if (intervalPeriod > (intervalStep * 5)) {
              this.clearInterval();
              this.onBuildFailure($scope);
            }

            // При привышении максимального количества запросов - увеличим период
            if (intervalCount > maxIntervalCount) {
              this.clearInterval();

              const newIntervalPeriod = intervalPeriod + intervalStep;
              this.showBuildStatus(Section, $scope, type, newIntervalPeriod, intervalStep, maxIntervalCount);
            }

            intervalCount++;
          }, () => {
            this.onBuildFailure($scope);
          });

        }, intervalPeriod);
      }

      clearInterval() {
        $interval.cancel(this.intervalId);
        this.intervalId = null;
      }

      onBuildFailure($scope) {
        $scope.buildIsNotFinish = false;
        Notification.error({
          message: $filter('translate')('site.error')
        });
      }

      removeVisibilityDelay() {
        $('.visibility_delay_enable').each((index, item) => {
          const $item = $(item);
          $item.removeClass('visibility_delay_enable');
        });
      }

      /**
       * Создадим запись об ошибке в scope
       * @param $scope
       * @param field
       * @param message
       */
      createError($scope, field, message) {
        if (!$scope.error) {
          $scope.error = {};
        }

        $scope.error[field] = message;
      }

      /**
       * Удалим ошибку из scope
       * @param $scope
       * @param field
       */
      clearError($scope, field) {
        if ($scope.error && $scope.error[field]) {
          $scope.error[field] = false;
        }
      }
    }

    return new EditorLibrary();
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/editorLibrary.js